import api from "../../../api";
import { createChartHistoryLoader } from "../../../utils/chartHistory";

const loadChartHistory = createChartHistoryLoader(params => api.getLocationEventsIndex(params));

export default {
  async getDeviceEvents({ commit }, obj) {
    // console.log("store: obj")
    commit("REQUEST_DEVICE_EVENTS");
    commit("SET_LOADING", true, { root: true });
    try {
      const response = await api.getDeviceEvents(obj);
      commit("SUCCESS_REQUEST_DEVICE_EVENTS", response);
      return response.body;
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_DEVICE_EVENTS");
      return [];
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getLocationEventsIndex({ commit, rootState }, obj) {
    commit("REQUEST_LOCATION_EVENTS_INDEX");
    commit("SET_LOADING", true, { root: true });
    try {
      if (obj.chart) {
        const user = rootState?.auth?.mySelf || {};
        const scope = JSON.stringify([user._id, user.data_access, rootState?.metadata_sync?.scopeKey]);
        const rows = await loadChartHistory(obj, scope);
        commit("SUCCESS_REQUEST_CHART_HISTORY");
        return rows;
      }
      const response = await api.getLocationEventsIndex(obj);
      commit("SUCCESS_REQUEST_LOCATION_EVENTS_INDEX", response);
      return response.body;
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      if (obj.chart) {
        commit("FAILURE_REQUEST_CHART_HISTORY");
        throw err;
      }
      commit("FAILURE_REQUEST_LOCATION_EVENTS_INDEX");
      return [];
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }

};
